import React, { useContext, useEffect } from "react";
import { Box, Button, TextField, useMediaQuery, useTheme } from "@mui/material";
import { GlobalContext } from "../Utils/Contexts";
import { DatePicker } from "@mui/x-date-pickers";
import { isValidDate } from "../Utils/UtilityMethods";
import NextTicketIcon from "@mui/icons-material/FastForward";
import PreviousTicketIcon from "@mui/icons-material/FastRewind";
import dayjs from "dayjs";

const DATE_FORMAT = "YYYY-MM-DD";
const LEFT_ARROW_KEY_CODE = 37;
const RIGHT_ARROW_KEY_CODE = 39;
export default function DateNavigator(): JSX.Element {
    const context = useContext(GlobalContext);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    useEffect(() => {
        context.setSelectedDate(`${new Date().toISOString().slice(0, 10)}`); // set current date as selectedDate on startup
        context.setSelectedDatesList(`${new Date().toISOString().slice(0, 10)}`);
    }, []);

    function selectPreviousDate() {
        const selectedDate = dayjs(context.selectedDate);
        const previousDate = selectedDate.subtract(1, "day");

        if (isValidDate(previousDate.toDate().toDateString())) {
            context.setSelectedDate(previousDate.format(DATE_FORMAT));
            context.setSelectedDatesList(previousDate.format(DATE_FORMAT));
        }
    }

    function selectNextDate() {
        const selectedDate = dayjs(context.selectedDate);
        const nextDate = selectedDate.add(1, "day");

        if (isValidDate(nextDate.toDate().toDateString())) {
            context.setSelectedDate(nextDate.format(DATE_FORMAT));
            context.setSelectedDatesList(nextDate.format(DATE_FORMAT));
        }
    }

    function handleArrowKeysDown(e: { keyCode: number }) {
        if (e.keyCode === LEFT_ARROW_KEY_CODE) selectPreviousDate();
        else if (e.keyCode === RIGHT_ARROW_KEY_CODE) selectNextDate();
    }

    useEffect(() => {
        // use left/right arrow keys to move to previous/next date
        document.addEventListener("keydown", handleArrowKeysDown);
        return () => document.removeEventListener("keydown", handleArrowKeysDown);
    });

    return (
        <Box sx={{ mt: 3, mb: 2, display: "flex", alignItems: "flex-start" }}>
            {!isMobile ? (
                <Button variant="contained" size="medium" title="Previous Day" color="secondary" sx={{ mr: 1 }} onClick={selectPreviousDate}>
                    <PreviousTicketIcon />
                </Button>
            ) : null}
            <DatePicker
                inputFormat={DATE_FORMAT}
                value={context.selectedDate}
                renderInput={(params) => (
                    <TextField
                        required
                        id="date"
                        sx={{ backgroundColor: "white", borderRadius: 2, mt: -1, width: 150 }}
                        fullWidth
                        margin="normal"
                        {...params}
                    />
                )}
                onChange={(value) => {
                    if (isValidDate(value ?? "")) {
                        const newDate = dayjs(value ?? Date.now());

                        context.setSelectedDate(`${newDate.format(DATE_FORMAT)}`);
                        context.setSelectedDatesList(`${newDate.format(DATE_FORMAT)}`);
                    }
                }}
            />
            {!isMobile ? (
                <Button variant="contained" size="medium" title="Next Day" color="secondary" sx={{ ml: 1 }} onClick={selectNextDate}>
                    <NextTicketIcon />
                </Button>
            ) : null}
        </Box>
    );
}
